import type { StudioId } from '@/lib/studios';

// "Make one like this" -> the studio. The photos or story picked in the
// Reel's sheet are held in memory (never stored or uploaded here) and the
// studio takes them once on arrival, so nobody is asked twice. A full page
// load drops them, which only means the studio asks again.

export interface ReelHandoff {
  studio: StudioId;
  files?: File[];
  text?: string;
  itemId: string;
}

let pending: ReelHandoff | null = null;

export function setReelHandoff(h: ReelHandoff | null) {
  pending = h;
}

/** The handoff for this studio, once. */
export function takeReelHandoff(studio: StudioId): ReelHandoff | null {
  if (!pending || pending.studio !== studio) return null;
  const h = pending;
  pending = null;
  return h;
}

/** A FileList from files, for handlers that take one (corrido addPhotos). */
export function toFileList(files: File[]): FileList | null {
  try {
    const dt = new DataTransfer();
    files.forEach((f) => dt.items.add(f));
    return dt.files;
  } catch {
    return null;
  }
}
